import { hasClass } from '@opten/dom/has-class';
import { addClass } from '@opten/dom/add-class';
import { Select } from '@opten/select';
//import { Select } from '.components/select';

import { getDatepicker } from '../../../Opten.HypothekarbankLenzburg.Core.Static/components/datepicker';

export function getFields(form: HTMLFormElement, ignore: Array<string> = []) {
    const fields = new Map<
        string,
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >();

    if (ignore && ignore.length) {
        ignore = ignore.map(o => o.toLowerCase());
    }

    Array.from(form.getElementsByTagName('input'))
        .filter(o => o.name && ignore.indexOf(o.name.toLowerCase()) === -1)
        .forEach(input => {
            // more or less just because of checkboxes...
            if (!fields.has(input.name)) {
                fields.set(input.name, input);
            }
        });

    Array.from(form.getElementsByTagName('textarea'))
        .filter(o => o.name && ignore.indexOf(o.name.toLowerCase()) === -1)
        .forEach(textarea => {
            if (!fields.has(textarea.name)) {
                fields.set(textarea.name, textarea);
            }
        });

    Array.from(form.getElementsByTagName('select'))
        .filter(o => o.name && ignore.indexOf(o.name.toLowerCase()) === -1)
        .forEach(select => {
            if (!fields.has(select.name)) {
                fields.set(select.name, select);
            }
        });

    return fields;
}

export function mapFields(
    form: HTMLFormElement,
    ignore: Array<string> = []
): Map<string, string> {
    // todo: better way? Some browsers doesn't allow to read FormData
    const fields = new Map<string, string>();

    const map = (
        input: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    ): string => {
        if (hasClass(input, 'js-text-mask-currency')) {
            return input.value
                .replace(/\'/g, '')
                .replace(/CHF/g, '')
                .replace(/\./g, '')
                .trim();
        } else if (hasClass(input, 'js-datepicker-field-hidden')) {
            const datepicker = getDatepicker(input as HTMLInputElement);

            return `${input.value};${datepicker ? datepicker.value : ''}`;
        } else if (input.type === 'checkbox') {
            return (input as HTMLInputElement).checked ? 'true' : 'false';
        }

        return input.value;
    };

    getFields(form, ignore).forEach(input => {
        if (!fields.has(input.name)) {
            fields.set(input.name, map(input));
        }
    });

    return fields;
}

export function setFieldsFromJson(
    form: HTMLFormElement,
    selects: Array<Select>,
    json: Object,
    ignore: Array<string> = [],
    filter: (
        field: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement,
        propName: string
    ) => boolean = (field, propName) => field.name === propName
) {
    getFields(form, ignore).forEach(field => {
        Object.keys(json).forEach(propName => {
            if (filter(field, propName)) {
                if (field.tagName.toLowerCase() === 'select') {
                    const select = selects.find(
                        // bug in select() that js-select is also applied to created element
                        // therefore multiple instances are found...
                        o => o && o.name && o.name === field.name
                    );

                    if (select) {
                        select.htmlSelectElement.value = json[propName];
                        select.htmlSelectElement.dispatchEvent(new Event('change'));
                    }
                } else {
                    if (field.type === 'checkbox') {
                        (field as HTMLInputElement).checked = json[propName]
                            ? String(json[propName]).toLowerCase() === 'true'
                            : false;
                    } else if (hasClass(field, 'js-datepicker-field-hidden')) {
                        // check for datepicker
                        const datepicker = getDatepicker(
                            field as HTMLInputElement
                        );

                        if (datepicker) {
                            const values = json[propName].split(';');

                            field.value = values[0];
                            datepicker.value = values[1];

                            // hack for input-fields-filled.ts
                            if (datepicker.value) {
                                addClass(datepicker, '--is-filled');
                            }
                        }
                    } else if (field.type === 'hidden') {
                        field.value = json[propName];
                    } else {
                        field.value = json[propName];

                        // hack for input-fields-filled.ts
                        if (field.value) {
                            addClass(field, '--is-filled');
                        }
                    }
                }
            }
        });
    });
}
